import React, { useState } from "react";
import Button from "components/button";
import IndexModal from "components/modal";
import { History, ShoppingCart } from "lucide-react";


const StoreAction = ({
    children,
    cartItems = []
}) => {
    const [modalType, setModalType] = useState(null); 
    const closeModal = () => setModalType(null);

    return (
        <>
             <Button
                onClick={() => setModalType("history")}
                className="access-button btn-history !h-10 !text-sm !px-6 !gap-2 !font-semibold"
            >
                <History className="w-5 h-5" />
                History
            </Button>

            <Button
                onClick={() => setModalType("cart")}
                className="access-button btn-cart !font-semibold"
            >
                <ShoppingCart className="w-5 h-5 mr-2" />
                {cartItems.length > 0 && (
                    <span className="text-xs font-medium whitespace-nowrap shrink-0 gap-1 transition-[color,box-shadow] overflow-hidden absolute -top-2 -right-2 bg-red-500 text-white border-2 border-white h-6 w-6 rounded-full p-0 flex items-center justify-center"> 
                        {cartItems.reduce((sum, item) => sum + item.quantity, 0)}
                    </span>
                )}
                Cart
            </Button>

            <IndexModal
                open={!!modalType}
                onClose={closeModal}
                useCustomClass={true}
                maxContentHeight="770px"
                width="512px"
            >
                {React.isValidElement(children) &&
                    React.cloneElement(children, {
                        type: modalType,
                        onClose: closeModal,
                    })}
            </IndexModal>
        </>
    );
};

export default StoreAction;
